import { useNavigate } from "react-router-dom";


const Footer = () => {

    const navigate = useNavigate();

    return (
        <div className=" px-[30px] bg-primary text-white mt-[50px]">
            <div className=" grid grid-cols-12 gap-4">

                <div className="col-span-12 md:col-span-12 py-[20px]">
                    <div className=" flex flex-col justify-center items-center">
                        <div className=" w-full md:w-[500px] flex flex-col md:flex-row items-center justify-center gap-10">
                            <span onClick={() => navigate("/faq")} className=" block cursor-pointer font-semibold text-sm"> အမေးအဖြေများ </span>
                            {/* <a href="#" className=" block cursor-pointer font-semibold text-sm"> စည်းမျဥ်းစည်းကမ်းများ </a> */}
                            <span onClick={() => navigate("/privacy")} className=" block cursor-pointer font-semibold text-sm"> ကိုယ်ရေးကိုယ်တာမူဝါဒ </span>
                        </div>
                    </div>
                </div>

                <div className="col-span-12 md:col-span-12 py-[20px]">
                    <div className=" flex flex-col justify-center items-center">
                        <div className=" w-full md:w-[500px] flex flex-col md:flex-row items-center justify-center gap-10">
                            <span className="text-sm"> Copyright © 2024 Driver Team Ride-Hailing Co., Ltd. All Rights Reserved.
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer;